import { BaseIncentivationDataModel } from "./incentivationDataModel";
import { BaseSubtypeDataModel } from "./subtypeData";

export interface ActionModuleInstanceResponse {
    id: number;
    employeeUserId: string;
    startDate: string;
    endDate: string;
    status: InstanceStatus;
    completedAt: string | null;
    closedAt: string | null;
    incentivationData: BaseIncentivationDataModel | null;
    rewardStatus: RewardStatus | null;
    subtypeData: BaseSubtypeDataModel[];
}

export enum InstanceStatus {
    Open = "Open",
    Completed = "Completed",
    Closed = "Closed",
    Orphaned = "Orphaned",
}
export enum RewardStatus {
    NoReward = "NoReward",
    RewardPending= "RewardPending",
    RewardApproved= "RewardApproved",
    RewardDeclined = "RewardDeclined",
}